import axios, { AxiosRequestConfig } from "axios";
import { ApiResponse } from "@/api/ApiResponse";

import { config } from "@/config/config";
import loginModule from "@/store/LoginModule";
import { UseTypeList } from "@/store/UseTypeModule";

export interface UseTypeResponse extends ApiResponse {
  result: {
    useTypeList: UseTypeList;
  };
}

class UseTypeApi {
  API_SERVER = config.api.access_url;

  /**
   * エラーリスト取得
   * @return {Promise<string, UseTypeResponse>} httpステータス・APIレスポンス・用途種別リスト
   */
  public async getUseTypeList(): Promise<{
    httpStatus: number;
    useTypeResponse: UseTypeResponse;
  }> {
    const url = this.API_SERVER + "/api/use-types/";
    const config: AxiosRequestConfig = {
      headers: {
        "Content-Type": "application/json",
        auth: loginModule.token,
      },
    };
    const response = await axios.get<UseTypeResponse>(url, config);
    return {
      httpStatus: response.status,
      useTypeResponse: response.data,
    };
  }
}

export const useTypeApi = new UseTypeApi();
